import React, { useEffect } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormLabel,
  RadioGroup,
  Radio,
  FormControl,
  Typography,
  Accordion,
  Grid,
  Box,
  Button,
  AccordionDetails,
  AccordionSummary,
  TextField,
} from "@mui/material";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function Level8(props) {
  const [level8, setLevel8] = React.useState({
    isNatural: false,
    isHerbal: false,
    isTraditional: false,
    barcode: null,
    discontinue: false,
    isOnlineSell: true,
    isSuspend: false,
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (props.fireGetData) {
      props.getDataFromLevel8(level8);
    }
  }, [props.fireGetData]);

  return (
    <Accordion
      expanded={props.expanded === "panel8"}
      style={{ margin: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography>مرحله هشتم</Typography>
      </AccordionSummary>

      <AccordionDetails>
        <Box>
          <Grid container spacing={3}>
            <Grid item xs={isSmall ? 12 : 3}>
              <TextField
                sx={{ direction: "rtl" }}
                id="outlined-basic"
                size="small"
                fullWidth
                value={level8.barcode ? level8.barcode : ""}
                label="بارکد محصول"
                variant="outlined"
                onChange={(evt) => {
                  if (evt.target.value) {
                    setLevel8({
                      ...level8,
                      barcode: evt.target.value,
                    });
                  } else {
                    setLevel8({
                      ...level8,
                      barcode: null,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={isSmall ? 0 : 9}></Grid>
            <Grid item xs={isSmall ? 12 : 3}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={setLevel8.isNatural}
                      onChange={(evt) => {
                        setLevel8({
                          ...level8,
                          isNatural: evt.target.checked,
                        });
                      }}
                    />
                  }
                  label="محصول فرآورده طبیعی است ."
                />
              </FormGroup>
            </Grid>
            <Grid item xs={isSmall ? 12 : 3}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={setLevel8.isHerbal}
                      onChange={(evt) => {
                        setLevel8({
                          ...level8,
                          isHerbal: evt.target.checked,
                        });
                      }}
                    />
                  }
                  label="محصول  گیاهی است ."
                />
              </FormGroup>
            </Grid>
            <Grid item xs={isSmall ? 12 : 3}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={setLevel8.isTraditional}
                      onChange={(evt) => {
                        setLevel8({
                          ...level8,
                          isTraditional: evt.target.checked,
                        });
                      }}
                    />
                  }
                  label="محصول  طب سنتی است ."
                />
              </FormGroup>
            </Grid>
            <Grid item xs={isSmall ? 12 : 3}></Grid>
            <Grid item xs={12}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(level8.discontinue)}
                      value={level8.discontinue}
                      onChange={(evt) => {
                        setLevel8({
                          ...level8,
                          discontinue: evt.target.checked,
                        });
                      }}
                    />
                  }
                  label="تولید محصول متوقف شده است."
                />
              </FormGroup>
            </Grid>

            <Grid item xs={isSmall ? 12 : 3}>
              <FormControl>
                <FormLabel
                  color="secondary"
                  sx={{ fontWeight: "bold" }}
                  id="demo-radio-buttons-group-label"
                >
                  فروش آنلاین :
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                  value={level8.isOnlineSell}
                  onChange={(evt) => {
                    setLevel8({
                      ...level8,
                      isOnlineSell: JSON.parse(evt.target.value),
                    });
                  }}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="دارد"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="ندارد"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={isSmall ? 12 : 3}>
              <FormControl>
                <FormLabel
                  color="secondary"
                  sx={{ fontWeight: "bold" }}
                  id="demo-radio-buttons-group-label"
                >
                  تعلیق محصول :
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                  value={level8.isSuspend}
                  onChange={(evt) => {
                    setLevel8({
                      ...level8,
                      isSuspend: JSON.parse(evt.target.value),
                    });
                  }}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="تعلیق"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="عدم تعلیق"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Button
            sx={{ width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              props.setExpanded("panel7");
            }}
          >
            مرحله قبل
          </Button>
          {/* <Button
            sx={{ width: "100px" }}
            variant="contained"
            color="secondary"
            onClick={() => {
              props.setExpanded("panel8");
            }}
          >
            ثبت
          </Button> */}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
